import React from 'react';
import Component from '@vfuk/core-block';
const Block = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Block;
